import { AuthDynamoDB } from './dynamodb'
import AwsExports from '@/assets/aws-exports'

export default class User {
  userId: string
  db: AuthDynamoDB
  constructor (userId: string) {
    this.userId = userId
    this.db = new AuthDynamoDB()
  }

  async getPreSurvey () {
    const params = {
      TableName: AwsExports.resourceNamePrefix + '-PreSurvey',
      KeyConditionExpression: 'userId = :userId',
      ExpressionAttributeValues: {
        ':userId': this.userId
      }
    }
    return this.db.query(params)
      .then((result: any) => {
        return result.Items[0]
      }).catch((e: any) => {
        console.log(e)
      })
  }

  async getLesson () {
    const params = {
      TableName: AwsExports.resourceNamePrefix + '-Lesson',
      KeyConditionExpression: 'userId = :userId',
      ExpressionAttributeValues: {
        ':userId': this.userId
      }
    }
    return this.db.query(params)
      .then((result: any) => {
        return result.Items[0]
      }).catch((e: any) => {
        console.log(e)
      })
  }

  async getSelfCheck () {
    const params = {
      TableName: AwsExports.resourceNamePrefix + '-SelfCheck',
      KeyConditionExpression: 'userId = :userId',
      ExpressionAttributeValues: {
        ':userId': this.userId
      }
    }
    return this.db.query(params)
      .then((result: any) => {
        return result.Items
      }).catch((e: any) => {
        console.log(e)
      })
  }

  async getWorksheet (moduleName: string) {
    const params = {
      TableName: AwsExports.resourceNamePrefix + '-' + moduleName.toUpperCase() + 'Worksheet',
      KeyConditionExpression: 'userId = :userId',
      FilterExpression: 'attribute_not_exists(deletedAt)',
      ExpressionAttributeValues: {
        ':userId': this.userId
      }
    }
    console.log('getWorksheet', params)
    return this.db.query(params)
      .then((result: any) => {
        return result.Items
      }).catch((e: any) => {
        console.log(e)
      })
  }

  /**
   * 指定した日付のワークシートデータを取得
   */
  async getWorksheetWithDate (moduleName: string, columnName: string, date: Date) {
    console.log(date.toISOString())

    const params = {
      TableName: AwsExports.resourceNamePrefix + '-' + moduleName.toUpperCase() + 'Worksheet',
      KeyConditionExpression: 'userId = :userId',
      FilterExpression: `attribute_not_exists(deletedAt) AND ${columnName} = :date`,
      ExpressionAttributeValues: {
        ':userId': this.userId,
        ':date': date.toISOString()
      }
    }
    return this.db.query(params)
      .then((result: any) => {
        return result.Items
      }).catch((e: any) => {
        console.log(e)
      })
  }
}
